import { clannAxios as axios } from '../utils/axiosInstances';

export function getCategoriesAPI() {
  return axios.get('events/calendars');
}

export function getEventsAPI(categories) {
  return axios.get(`events?params=${categories}`);
}

export function suggestEventAPI(data) {
  return axios.post('events', data);
}
